import {
    ACT_EMP_ADD_INIT,
    ACT_EMP_ADD_201,
    ACT_EMP_FETCH_INIT,
    ACT_EMP_FETCH_200,
    ACT_EMP_UPDATE_INIT,
    ACT_EMP_UPDATE_200,
    ACT_EMP_DELETE,
} from "../constants/actions";

const defaultState = {
    isLoadingEmployees: true,
    didLoadEmployees: false,
    isAddingEmployee: false,
    employeesList: [],
};


const employeesReducer = (state = defaultState, action) => {
    console.log('Emp reducer state action', state, action);
    switch (action.type) {
        case ACT_EMP_FETCH_INIT:
            return {
                ...state,
                isLoadingEmployees: true,
                didLoadEmployees: false,
                employeesList: [],
            };
        case ACT_EMP_FETCH_200:
            return {
                ...state,
                isLoadingEmployees: false,
                didLoadEmployees: true,
                employeesList: action.employees,
            }
        case ACT_EMP_ADD_INIT:
            return {
                ...state,
                isAddingEmployee: true,
            };
        case ACT_EMP_ADD_201:
            let newEmployeesList = [action.employee].concat(state.employeesList);
            return {
                ...state,
                isAddingEmployee: false,
                employeesList: newEmployeesList,
            };
        case ACT_EMP_UPDATE_INIT:
            return {
                ...state,
                isAddingEmployee: true,
            };
        case ACT_EMP_UPDATE_200:
            let newUpdatedEmployeesList = [action.employee].concat(state.employeesList);
            return {
                ...state,
                isAddingEmployee: false,
                employeesList: newUpdatedEmployeesList,
            };
        case ACT_EMP_DELETE:
            return {};
        default:
            return state;

    }
};

export default employeesReducer;
